import { ALTERAR_DETALHAMENTO_VEICULO } from '../types'

export default function alterarExibicaoDetalhamentoPedido (pedido) {
  return {
    type: ALTERAR_DETALHAMENTO_VEICULO,
    payload: pedido
  }
}
